import { render, staticRenderFns } from "./ConversationView.vue?vue&type=template&id=58ec6445&scoped=true&"
import script from "./ConversationView.vue?vue&type=script&lang=js&"
export * from "./ConversationView.vue?vue&type=script&lang=js&"
import style0 from "./ConversationView.vue?vue&type=style&index=0&id=58ec6445&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ec6445",
  null
  
)

export default component.exports